import React, { useState, useEffect } from "react";
import { Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { TailSpin } from "react-loader-spinner";
import { GetState, GetStateFromData } from "./CustomHooks/CustomHooks";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 5,
    pointerEvents: "auto !important",
    color: "#fff"
  },
  container: {
    zIndex: "2",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px"
  },
  message: {
    color: (style) => style.loaderColor,
    fontSize: "16px !important"
  }
}));

export const Loading = (props) => {
  const loaderColor = "#fff";
  const classes = useStyles({ loaderColor });
  const { t } = useTranslation(["styles", "translation"]);
  const {loadingState} = GetState("loadingState");

  useEffect(()=>{
    if(loadingState?.open === true || loadingState?.open === "true"){
      if(document.getElementById('root')){
        document.getElementById('root').style.pointerEvents = 'none';
      }
    }
    else{
      if(document.getElementById('root')){
        document.getElementById('root').style.pointerEvents = 'auto';
      }
    }
    if(loadingState?.displayLoader === true || loadingState?.displayLoader === "true"){
      if(document.getElementById("Loader_Backdrop")){
        document.getElementById("Loader_Backdrop").style.pointerEvents = "none";
      }
    } else {
      if(document.getElementById("Loader_Backdrop")){
        document.getElementById("Loader_Backdrop").style.pointerEvents = "auto";
      }
    }
  },[loadingState?.open, loadingState?.displayLoader ]);
  
  return (
    <Backdrop id="Loader_Backdrop" className={classes.backdrop} open={loadingState?.open}>
      {loadingState?.displayBackdrop && (
        <div className={classes.container}>
          {loadingState?.open && (
            <>
              {loadingState?.displayLoader && (
                <TailSpin height="50" width="50" strokeWidth={3} color={loaderColor} ariaLabel="mf_afb_loader" />
              )}
              <h6 className={classes.message}>{t(loadingState?.message)}</h6>
            </>
          )}
        </div>
      )}
    </Backdrop>
  );
};
